import {type Type, Plugins} from '@packages/systems/wfdl';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';
export const migrateNumberDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'Number') {
    const newDataType: Type = {
      type: 'TypeConstructor',
      val: qualify(Plugins.name('Builtin'), typeName('Number')),
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
